import { getFirebaseApp } from '../core';

function read(id, path) {
  return new Promise((resolve, reject) => {
    const firebase = getFirebaseApp();
    return firebase
      .database()
      .ref(`${path}/${id}`)
      .once('value')
      .then(snapshot => resolve(snapshot.val()))
      .catch(reject);
  });
}

export default read;
